import script from "./Top.vue?vue&type=script&lang=ts"
export * from "./Top.vue?vue&type=script&lang=ts"

import "./Top.vue?vue&type=style&index=0&id=aa8c71a2&lang=css"

export default script